/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 受入拒否理由
 */
export type RejectReasonByEmsEnum =
  (typeof RejectReasonByEmsEnum)[keyof typeof RejectReasonByEmsEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RejectReasonByEmsEnum = {
  OPERATION: 'OPERATION',
  PATIENT_CARE: 'PATIENT_CARE',
  FULL_BEDS: 'FULL_BEDS',
  OPERATION_PATIENT_CARE: 'OPERATION_PATIENT_CARE',
  DIFFICULT: 'DIFFICULT',
  NOT_SPECIALIZED: 'NOT_SPECIALIZED',
  DOCTOR_ABSENT: 'DOCTOR_ABSENT',
  FIRST_VISIT: 'FIRST_VISIT',
  UNKNOWN: 'UNKNOWN',
  SELF_REFERRED: 'SELF_REFERRED',
} as const;
